import client from '@stores/apollo'
import { IEdge, IEmployeeWithBookings } from '@api/types'
import { adminEmployeeSpaceSearch } from './queries'

export interface Payload {
  data: {
    viewer: {
      company: {
        employeeConnection: { edges: IEdge<IEmployeeWithBookings>[] }
      }
    }
  }
}

export default function employeeBookings({
  ids,
}: {
  ids: string[]
}): Promise<IEmployeeWithBookings[]> {
  const variables = {
    ids,
  }

  return client.gql.query({ query: adminEmployeeSpaceSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            employeeConnection: { edges },
          },
        },
      },
    }: Payload) => edges.map(({ node }: { node: IEmployeeWithBookings }) => node)
  )
}
